import { UpdateChatStatusSocket } from "../entities/UpdateChatStatusSocket";
import { ChatSocketRepository } from "../repositories/ChatSocketRepository";

export class UpdateChatStatus {
	constructor(private repository: ChatSocketRepository) {}

	execute(params: UpdateChatStatusParams): Promise<void> {
		return this.repository.updateChatStatus(params.params);
	}
}

export class UpdateChatStatusParams {
	constructor(public params: UpdateChatStatusSocket) {}
}
